import usePageTitle from '../../hoook/usePageTitle'

function TermsOfUse() {
    usePageTitle('- Terms of Use')
    return (
        <div className="container">
            <div className="card">
                <div className="card-body">
                    <div
                        name="termly-embed"
                        data-id="b77937b2-7c78-44e7-8fea-dafedb245d4b"
                        data-type="iframe"
                    />
                </div>
            </div>
        </div>
    )
}

export default TermsOfUse
